export default function Plugin({ plugin, showMonthlyPrice, url }) {
  return (
    <div className={`flex flex-col rounded-md border-t-8 border hover:border-slate-300 p-4 hover:shadow-xl transition duration-300`}>
      <div className="flex">
        <h2 className="text-lg font-medium mb-4 flex-grow">{plugin.name}</h2>
        <span className="relative mr-3 ml-4 px-2 h-[20px] text-sm">
          <span className={`absolute -inset-1 block -skew-y-3 ${plugin.price ? 'bg-sky-500' : 'bg-green-500'}`} aria-hidden="true"></span>
          <span className="relative text-white">{plugin.price ? 'Paid' : 'Free'}</span>
        </span>
      </div>
      <div className="flex-grow">
        {plugin.country &&
          <p className="mb-4"><span className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded-sm">{plugin.country}</span></p>}
        <p className="mb-4">{plugin.description}</p>
        {plugin.price && <div className="mt-3"><span className='bg-purple-100 text-blue-800 text-sm font-medium px-3 py-2 rounded'>${plugin.monthlySubscriptionAvailable && showMonthlyPrice ? plugin.price : plugin.price * 10} USD / {plugin.monthlySubscriptionAvailable && showMonthlyPrice ? 'month' : 'year'} per store</span></div>}
      </div>
      <div className="text-center mt-8">
        <a href={url} className="hover:no-underline text-slate-800 px-6 py-2 inline-flex text-base font-medium text-center text-gray-900 border border-gray-300 transition-colors duration-300 rounded-full hover:bg-gray-100 focus:ring-4 focus:ring-gray-100">
          Learn more
        </a>
      </div>
    </div>
  );
}